<template>
  <div class="space-y-4">
    <div class="text-center font-heiti">表 2-1-3 数字化管理维度的采集项层级评测得分</div>
    <div class="grid grid-cols-5 w-full text-center items-center border-t border-solid border-black">
      <div class="col-span-1 border-b border-solid border-black py-2 font-heiti">二级指标</div>
      <div class="col-span-1 border-b border-solid border-black py-2 font-heiti">采集项</div>
      <div class="col-span-3 border-b border-solid border-black py-2 font-heiti">评测得分情况</div>
      <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">B1 规划管理</div>
      <div class="col-span-4 grid grid-cols-4 border-b border-solid border-black py-2">
        <div class="col-span-1 h-full flex justify-center items-center py-1">B11 规划实施</div>
        <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[7].score / 7.5 * 100, label: info.answerArr[7].score * 1 || 0, rate: (info.answerArr[7].score / 7.5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '7.5'}" />
        <div class="col-span-1 h-full flex justify-center items-center py-1">B12 管理机制</div>
        <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[8].score / 7.5 * 100, label: info.answerArr[8].score * 1 || 0, rate: (info.answerArr[8].score / 7.5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '7.5'}" />
      </div>
      <div class="col-span-1 border-b border-solid border-black h-full flex justify-center items-center py-2 font-heiti">B2 要素保障</div>
      <div class="col-span-4 grid grid-cols-4 border-b border-solid border-black py-2">
        <div class="col-span-1 h-full flex justify-center items-center py-1">B21 人才建设</div>
        <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[9].score / 7.5 * 100, label: info.answerArr[9].score * 1 || 0, rate: (info.answerArr[9].score / 7.5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '7.5'}" />
        <div class="col-span-1 h-full flex justify-center items-center py-1">B22 资金保障</div>
        <rate-bar class="col-span-3 py-1" :yellow="{val: info.answerArr[10].score / 7.5 * 100, label: info.answerArr[10].score * 1 || 0, rate: (info.answerArr[10].score / 7.5 * 100).toFixed(3) * 1 + '%'}" :blue="{val: 100, label : '7.5'}" />
      </div>
    </div>
  </div>
</template>

<script>
import RateBar from '@/components/RateBar'

// 数字化管理维度2
export default {
  components: { RateBar },
  props: ['info']
}
</script>
